import React, { useState } from 'react';
import { Toggles } from '@gjensidige/builders-components';
import { PRODUCTS } from '../../../lib/constants/appConstants';

import {
  HeaderTab
} from '../../../interfaces/Types';
import { AppConstants } from '../../../utils/AppConstants';
import { InformationModal } from '../../Common/InformationModal/InformationModal';
import { useAppSelector } from '../../../hooks/appHooks';

interface Props {
  selectionTabs: HeaderTab[];
  updateTileSelection: (packageCode: string) => void;
}

export const InsuranceTileSelectionTabs: React.FC<Props> = ({
  selectionTabs,
  updateTileSelection
}) => {
  const { productName } = useAppSelector(
    (state) => state.insurance.offer
  );
  const [isRecommendedModalOpen, setRecommendedModalOpen] = useState(false);
  const selectedTab = selectionTabs.find((tab) => tab.isSelected);
  return (
    <div className="package-selection-list">
      {selectionTabs.length > 0 &&
        (
          <Toggles variant="white-separated" value={selectedTab ? selectedTab.packageCode : ''}>
            {
              selectionTabs.map((tab: HeaderTab) => {
                return (
                  <Toggles.Toggle
                    key={tab.packageCode}
                    value={tab.packageCode}
                    onClick={() => updateTileSelection(tab.packageCode)}
                    className={`package-selection-badge${tab.isEnabled ? '' : ' disabled'
                      }`}
                    tabIndex={0}
                  >
                    {tab.defaultPackage && tab.defaultPackageMessage && (
                      <div
                        className={`selected-top-banner ${isRecommendedModalOpen ? 'on-top' : ''
                          }`}
                      >
                        <div className="recommened-tile-small-text">
                          <InformationModal
                            linkText={productName === PRODUCTS.CAR ?
                              AppConstants.getAppText('webshop.insuranceRecommendedLabel')
                              :
                              AppConstants.getAppText('webshop.insuranceSelectedByMany')}
                            modalContent={[
                              {
                                title: productName === PRODUCTS.CAR ?
                                  AppConstants.getAppText('webshop.insurance.recommendedInfoLink')
                                  :
                                  AppConstants.getAppText('webshop.insuranceSelectedByMany'),
                                details: tab.defaultPackageMessage
                              }
                            ]}
                            buttonSize="sm"
                            buttonClassName="recommended-link"
                            openCallBack={(isOpen) => setRecommendedModalOpen(isOpen)}
                            modalAriaLabel='Hjälp om vårt förslag'
                          />
                        </div>
                      </div>
                    )}
                    {tab.packageName}
                  </Toggles.Toggle>
                );
              })
            }
          </Toggles>
        )
      }
    </div>
  );
};
